import Materials_A_0 from './Materials_A/Materials_A_0'
import Materials_A_1 from './Materials_A/Materials_A_1'
import Materials_A_2 from './Materials_A/Materials_A_2'
import Materials_A_3 from './Materials_A/Materials_A_3'
import Materials_A_4 from './Materials_A/Materials_A_4'
import Materials_A_5 from './Materials_A/Materials_A_5'
import Materials_A_6 from './Materials_A/Materials_A_6'
import Materials_A_7 from './Materials_A/Materials_A_7'

const Materials_A = [
  Materials_A_0,
  Materials_A_1,
  Materials_A_2,
  Materials_A_3,
  Materials_A_4,
  Materials_A_5,
  Materials_A_6,
  Materials_A_7
]

export default Materials_A



// WEBPACK FOOTER //
// ./src/components/Materials_A.js